import { useState, useEffect } from "react";
import { Shield, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FirewallAdvisorModal } from "@/components/products/FirewallAdvisorModal";
import { useLanguage } from "@/contexts/LanguageContext";

const translations = {
  nl: {
    buttonText: "Firewall Advies",
  },
  en: {
    buttonText: "Firewall Advice",
  },
  fr: {
    buttonText: "Conseil Firewall",
  },
};

const FirewallAdvisorFAB = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage as keyof typeof translations] || translations.nl;

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div
        className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
          isVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10 pointer-events-none"
        }`}
      >
        <Button
          onClick={() => setIsModalOpen(true)}
          size="lg"
          className="group relative overflow-hidden rounded-full px-6 py-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 animate-pulse-glow"
        >
          {/* Shimmer effect */}
          <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-primary-foreground/20 to-transparent" />
          
          <div className="relative flex items-center gap-2">
            <Shield className="h-5 w-5" />
            <span className="font-semibold">{t.buttonText}</span>
            <Sparkles className="h-4 w-4 animate-pulse" />
          </div>
        </Button>
      </div>

      <FirewallAdvisorModal open={isModalOpen} onOpenChange={setIsModalOpen} showTrigger={false} />
    </>
  );
};

export default FirewallAdvisorFAB;
